import $ from 'jquery';
import _ from 'lodash';
import PageBasePrototype from 'PageBasePrototype';

let images = [];

export default class ContentPage extends PageBasePrototype {
  build() {
    const imageSelectors = {
      productCard: '.product-card__image > img',
      textAndImageVertical: '.cms-image-and-text__image',
      textAndImageHorizontal: '.cms-image-and-text__image > source, .cms-image-and-text__inner-image',
      imageHero: '.image-hero__background',
      imageAndColumnSplit: '.image-and-column-split__picture source, .image-and-column-split__image',
      marketingBanner5050: '.marketing-banner-50-50__background',
      contentArticleTeaser: '.content-central-article-teaser__article--has-image',
      newProductCard: '.cms-plan-card__image > img',
      newMagnoliaCard: '.cms-new-magnolia-card__image-container > img',
      newMagnoliaCardBackgroundImage: '.cms-new-magnolia-card--has-image',
      channelPacakgeCard: '.cms-channel-package-card__image',
    };

    const combinedSelectors = Object.keys(imageSelectors).map((key) => { return imageSelectors[key]; }).join();
    this.imagesToLazyLoad = this.node.find(combinedSelectors);

    if (this.shouldLazyLoadImages()) {
      images = this.imagesToLazyLoad;
      this.lazyLoad();

      $(window).on('scroll', () => {
        this.lazyLoad();
      });

      $(window).on('resize', () => {
        this.lazyLoad();
      });
    }
  }

  shouldLazyLoadImages() {
    return this.data.lazyLoadImages;
  }

  lazyLoad() {
    _.each(images, (item) => {
      const image = item;

      if (this.isInViewport(image)) {
        const srcAttr = image.getAttribute('data-src');

        if (srcAttr) {
          image.src = srcAttr;
          image.removeAttribute('data-src');
        }

        const srcsetAttr = image.getAttribute('data-srcset');

        if (srcsetAttr) {
          image.srcset = srcsetAttr;
          image.removeAttribute('data-srcset');
        }

        const backgroundUrlAttr = image.getAttribute('data-background-url');

        if (backgroundUrlAttr) {
          image.style.backgroundImage = `url("${backgroundUrlAttr}")`;
          image.removeAttribute('data-background-url');
        }
      }
    });

    this.updateImageArray();
  }

  isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight));
  }

  updateImageArray() {
    images = Array.prototype.filter.call(images, (l) => { return l.hasAttribute('data-src') || l.hasAttribute('data-srcset') || l.hasAttribute('data-background-url'); } ); // eslint-disable-line
  }
}
